module.exports = __webpack_public_path__ + "static/Ocean_Chef_Salmon_Flat_Bottom-7c68aeb5c0253a8231b7a24eacd54038.jpg";